(function(){
  const accountCollectionSlider = function() {
    $('.js-account-slider').slick();
  }

  const aboutProgramSlider = function() {
    $('.js-program-slider').slick();
  }

  const faqAccordion = function() {
    const accordions = document.querySelectorAll('.js-faqs__item');
    const contentClass = '.js-faqs__slide';
    const contentOpener = '.js-faqs__btn-opener';
    const activeClass = 'accordion--active';

    const openAccordion = (accordion) => {
      const content = accordion.querySelector(contentClass);
      const opener = accordion.querySelector(contentOpener);
      accordion.classList.add(activeClass);
      opener.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = `${content.scrollHeight}px`;
      content.style.visibility = 'visible';
    };

    const closeAccordion = (accordion) => {
      const content = accordion.querySelector(contentClass);
      const opener = accordion.querySelector(contentOpener);
      accordion.classList.remove(activeClass);
      opener.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = null;
      content.style.visibility = 'hidden';
    };

    accordions.forEach((accordion) => {
      const opener = accordion.querySelector(contentOpener);
      const content = accordion.querySelector(contentClass);

      opener.onclick = () => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion);
        }
      };
    });
  }

  const initTabs = function() {
    const openerClass = ('.js-tab-opener');
    const tabParent = ('[data-table-tab]');
    const tabData = ('data-set-tab');
    const activeClass = ('active--tab');
    const tabOpeners = document.querySelectorAll(openerClass);

    if(!tabOpeners) {
      return;
    }

    const triggerClass = function(evt) {
      const parent = evt.target.closest(tabParent);
      const activeTab = evt.target.closest(openerClass).getAttribute(tabData);
      const tabDataList = parent.querySelectorAll(`[${tabData}]`);

      tabDataList.forEach((tabDataItem) => {
        const tabItemData = tabDataItem.getAttribute(tabData);

        if(tabItemData === activeTab) {
          tabDataItem.classList.add(activeClass);
        } else {
          tabDataItem.classList.remove(activeClass);
        }
      });
    }

    tabOpeners.forEach((popupOpener) => {
      popupOpener.addEventListener('click', triggerClass);
    });
  }

  window.initializeMobileTable = initTabs;

  accountCollectionSlider();
  aboutProgramSlider();
  faqAccordion();
  initTabs();
})();

